import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useParams } from "react-router-dom";

import QueryStringService from '../services/queryStringService.js';
import EMailService from '../services/emailService.js'
import LoadingIndicator from './LoadingIndicator.jsx'
import * as colors from '../services/colors.js'
const imgSource = require('../images/bmo-logo-dark.png');

function UnregisterEffectMeasureEMail(props) {
    const [apiHttpStatusCode, setApiHttpStatusCode] = useState(500);
    const [loading, setLoading] = useState(false);
    const [emailService] = useState(() => new EMailService());
    const [cmMailAddress, setCMMailAddress] = useState('');
    let { id } = useParams();

    useEffect(() => {
        setLoading(false);
        let countryCode = new QueryStringService().getCurrentCountry();
        switch (countryCode) {
            case 'se':
                setCMMailAddress('customersuccess-se@bauermediaoutdoor.com');
                break;
            case 'no':
                setCMMailAddress('campaignmanagement-no@bauermediaoutdoor.com');
                break;
            case 'dk':
                setCMMailAddress('customersuccess-dk@bauermediaoutdoor.com');
                break;
        }
        unregisterEMail(id);
    }, []);

    const unregisterEMail = (base64EncryptedEMail) => {
        setLoading(true);
        const success = (data, status, jqXHR) => {
            setApiHttpStatusCode(jqXHR.status);
            setLoading(false);
        };
        const error = (errorResult) => {
            setApiHttpStatusCode(errorResult.status);
            setLoading(false);
        };

        emailService.unregisterEfEMailAddress(base64EncryptedEMail, success, error);
    };

    const RenderResult = () => {
        if (apiHttpStatusCode === 201)
            return (
                <div className="row footer-email-text">
                    <p>You have now unsubscribed from receiving e-mails about effect measure.</p>
                    <p>If this was by mistake or you wish to start receiving e-mails again please contact <a href={`mailto:${cmMailAddress}`} style={{ textDecoration: "none" }}>{cmMailAddress}</a>.</p>
                </div>);
        else if (apiHttpStatusCode === 409)
            return (
                <div className="row footer-email-text">
                    <p>You have already unregisterd your email from recieving effect measure emails.</p>
                    <p>If you still receive these emails please contact <a href={`mailto:${cmMailAddress}`} style={{ textDecoration: "none" }}>{cmMailAddress}</a>.</p>
                </div>);
        return (
            <div className="row footer-email-text" >
                <p>Something went wrong when trying to unregister your email. Please try again. </p>
                <p>If the problem continues please contact <a href={`mailto:${cmMailAddress}`} style={{ textDecoration: "none" }}>{cmMailAddress}</a>.</p>
            </div>);
    }

    return (
        <div>
            <div className="container" style={{ maxWidth: "800px" }}>
                <img src={imgSource} width="100%" style={{ padding: "60px" }} />
            </div>
            <LoadingIndicator loading={loading} text={''} />
            {!loading ? RenderResult() : <div></div>}
        </div>
    );
};

export default UnregisterEffectMeasureEMail;
